/* import __COLOCATED_TEMPLATE__ from './ticket-id.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
import templateOnlyComponent from '@ember/component/template-only';
import type ConversationTableEntry from 'embercom/objects/inbox/conversation-table-entry';

interface Signature {
  Args: {
    conversationSummary: ConversationTableEntry;
  };
}

const TicketId = templateOnlyComponent<Signature>();
export default TicketId;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationsTable::TableCells::TicketId': typeof TicketId;
    'inbox2/conversations-table/table-cells/ticket-id': typeof TicketId;
  }
}
